import {FormatterBasic} from "./Core/FormatterBasic";
import * as React from "react";

export class FileUploadFormatter extends FormatterBasic {
    Format(): any {
        let name=this.GetValue('OriginalName');
        let link=this.GetValue('Value');
        if(link=='')
            return '';

        if(Array.isArray(link))
        {
            return (
                <div>
                    {link.map(currentLink=>
                        <div key={currentLink}>
                            <a target={'_blank'} href={currentLink}>{currentLink}</a>
                        </div>
                    )}
                </div>
            )
        }
        return <a target={'_blank'} href={link}>{name}</a>
    }

}